import { InjectionToken, Provider } from '@angular/core';
import { CampaignsApiService } from './campaigns-api.service';
import { CampaignsRepository } from './campaigns.repository';

export const HTTP_CAMPAIGNS_SERVICE = new InjectionToken<CampaignsRepository>('CampaignsRepository');

export const CAMPAIGNS_API_PROVIDER: Provider = {
    provide: HTTP_CAMPAIGNS_SERVICE,
    useClass: CampaignsApiService,
};
